/**
 * Human-readable labels for MEAS__* keys — prefer DB meas_display_names via map from CategoriesContext.
 */
import {
  buildMeasDisplayNameMap,
  type CategoryDef,
} from '../helpers/api/config/config';

let cachedDisplayMap: Record<string, string> = {};

export function setMeasurementDisplayMap(map: Record<string, string>): void {
  cachedDisplayMap = map;
}

export function refreshMeasurementDisplayMapFromCategories(
  categories: CategoryDef[]
): void {
  cachedDisplayMap = buildMeasDisplayNameMap(categories);
}

export function getMeasurementDisplayName(measName: string): string {
  if (measName.startsWith('meas_')) {
    const withoutPrefix = measName.replace(/^meas_/, '').replace(/_/g, ' ');
    return withoutPrefix.replace(/\b\w/g, (c) => c.toUpperCase());
  }
  const key = measName.split(/\s+/)[0];
  if (cachedDisplayMap[key]) return cachedDisplayMap[key];
  return key.replace(/^MEAS__/, '').replace(/_/g, ' ');
}

export {
  getAllowedMeasurementKeys,
  isMeasurementAllowed,
  measAllowed,
} from '../../../../ui/src/components/MeasurementTable/Components/Report/measurementAllowlist';
